import React, { Component } from 'react';
import { BrowserRouter, Switch, Route } from "react-router-dom";
import './App.css';
import Index from "./Pages/index";
import Login from "./Pages/login";
import Register from "./Pages/register";
import Recover from "./Pages/recover";
import Reset from "./Pages/reset";
import Dashboard from "./Pages/dashboard";
import ChangePassword from "./Pages/changepassword";
import ChangeAccount from "./Pages/changeaccount";
import ChangeRole from "./Pages/changerole";
import ChangeField from "./Pages/changefield";
import Submit from "./Pages/submit";
import Resubmit from "./Pages/resubmit";
import MySubmission from "./Pages/mysubmission";
import Review from "./Pages/review";
import MyReview from "./Pages/myreview";
import MyCommit from "./Pages/mycommit";
import Feedback from "./Pages/feedback";
import Publisher from "./Pages/publisher";
import Downloads from "./Pages/downloads";
import Details from "./Pages/details";
import Editdetails from "./Pages/editdetails";
import Wallet from "./Pages/wallet";
import Repository from "./Pages/repository";
import Contact from "./Pages/contact";
import Editors from "./Pages/editors";
import Summary from "./Pages/summary";
import PayPalSuccess from "./Pages/PayPalSuccess";
import PayPalCancel from "./Pages/PayPalCancel";
import NotFound from "./Pages/notFound";
import { UpdateState, doSaveDownloadFile, setChange } from "./Components/function";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import { appUrl } from './Constant';
import $ from 'jquery';

    // The dimensions are in millimeters.
    const A4_PAPER_DIMENSIONS = {
      width: 210,
      height: 297,
    };
    
    const A4_PAPER_RATIO = A4_PAPER_DIMENSIONS.width / A4_PAPER_DIMENSIONS.height;
    
    const ImageDimensionX = {
      width: 0,
      height: 0,
    }

    function addScript(url) {
      const script = document.createElement('script');
      script.type = 'application/javascript';
      script.src = url;
      document.head.appendChild(script);
  }

class App extends Component{

  constructor(props){
    super(props);
    
    this.state = {
      message: '',
    }
    }

    componentDidMount(){

      addScript('https://raw.githack.com/eKoopmans/html2pdf/master/dist/html2pdf.bundle.js');

      var that = this;

     $(function(){
     $(document).on('click', '.react-share__ShareButton', function(e){
      if($(this).attr('aria-label') == 'email'){
        window.location.href = 'mailto:?subject=Check out this Website&body=Here is the Website: '+appUrl;
      }
     })
     });

     $(function(){
      var pastValue, pastSelectionStart, pastSelectionEnd;
      $("#phone").on("keydown", function() {
          pastValue          = this.value;
          pastSelectionStart = this.selectionStart;
          pastSelectionEnd   = this.selectionEnd;
      }).on("input propertychange", function() {
          var regex = /^[0-9]+\.?[0-9]*$/;
                          
          if (this.value.length > 0 && !regex.test(this.value)) {
              this.value          = pastValue;
              this.selectionStart = pastSelectionStart;
              this.selectionEnd   = pastSelectionEnd;
          }
      }); 
      var pastValue, pastSelectionStart, pastSelectionEnd;
      $("#onlynumber, .onlynumber, .number, #number, .amount, #amount").on("keydown", function() {
          pastValue          = this.value;
          pastSelectionStart = this.selectionStart;
          pastSelectionEnd   = this.selectionEnd;
      }).on("input propertychange", function() {
          var regex = /^[0-9]+\.?[0-9]*$/;
                          
          if (this.value.length > 0 && !regex.test(this.value)) {
              this.value          = pastValue;
              this.selectionStart = pastSelectionStart;
              this.selectionEnd   = pastSelectionEnd;
          }
      }); 
     });


  function printDivToPDF(divElement, name = "") 
  {
  
    const input = document.querySelector(divElement);
    const divHeight = input.offsetHeight;
    const divWidth = input.offsetWidth;
    
    const ratio = divHeight / divWidth;
  
    html2canvas(input, { scale: '3' }).then((canvas) => {
      const imgData = canvas.toDataURL('image/jpeg');
      
      that.generatePdfFromImages([imgData], name);
    });
  
  }

  function DownloadFile(dataUri){
    let newWin = window.open(dataUri,'Download File'); 
    setTimeout(() => {
    newWin.close();
  }, 5000);
  }

  function SaveDownloads(scriptID, self){
    doSaveDownloadFile(self, scriptID); 
  }


$(function(){

$(document).on('click', '.download-file, #download-file', function(){
DownloadFile($(document).find(this).data('fileUrl'));
});

$(document).on('click', '.download-publisher, #download-publisher', function(){

DownloadFile($(document).find(this).data('fileUrl'));

SaveDownloads($(document).find(this).data('scriptid'), $(document).find(this).data('self'));

$(document).find('.publisher-scriptid').html($(document).find(this).data('scriptid'));
$(document).find('.publisher-author').html($(document).find(this).data('scriptauthor'));
$(document).find('.publisher-target').html($(document).find(this).data('scripttarget'));
$(document).find('.publisher-title').html($(document).find(this).data('scripttitle'));
$(document).find('.publisher-summary').html($(document).find(this).data('scriptsummary'));
$(document).find('.publisher-subdate').html($(document).find(this).data('scriptsubdate'));
$(document).find('.publisher-affiliate').html($(document).find(this).data('scriptaffiliate'));

//setTimeout(() => {
$(document).find('.publisher-pane').removeClass('hide');
printDivToPDF(".publisher-pane", "Publisher-"+$(document).find(this).data('scriptid'));
$(document).find('.publisher-pane').addClass('hide');
//}, 500);
});

});


$(function() {

$(document).on('click', '.print-feedback', function(e){
  let FeedFile = $(document).find(this).data('fileuri');
  printDivToPDF(".feedback-pane", $(document).find(this).data('scriptid'));
  if(typeof FeedFile !== 'undefined' && FeedFile != ""){
  DownloadFile(FeedFile);
  }
});

});


    $(function() {
    $('.disabled').each(function() {
    $(this).prop('title', "Disabled and Unavailable for Click Option");
    });

    $(document).on('click', '.close-modal', function(){
    $('.modal-content-overlay').removeClass('show-modal');
    });
    
    $(document).on('click', '.beta-btn', function(e){
    e.preventDefault();
    });
    
    $(document).on('click', '.tab .tab-tab', function(e){
      $(document).find('.tab .tab-tab').removeClass('active');
      $(this).addClass('active');
      $(document).find('.btn-activeable').removeClass('active');
    });
     
    $(document).on('click', '.btn-activeable', function(e){
    $(document).find('.btn-activeable').removeClass('active');
    $(this).addClass('active');
    });

    }.bind(this));
  
    
    $(function() {
    $(document).on('click', '.pagination', function(){
    $('.btn-activeable').removeClass('active');
    });
    });


$(function() {

$(document).on('click', '.download-file, #download-file', function(){
DownloadFile($(document).find(this).data('fileUri'));
});

});


$(function() {

var go_full_screen_iframe = document.querySelector('.go-full-screen-iframe');
go_full_screen_iframe?.addEventListener('click', fullscreen);
var isInFullScreenNOS = 0;

$(document).on('click', '.pop-review-modal', function(e){
isInFullScreenNOS = 0;
});

$(document).on('click', '.go-full-screen-iframe', function(e){
  isInFullScreenNOS++;
  var isInFullScreenN = (document.fullScreenElement && document.fullScreenElement !== null) ||    // alternative standard method  
            (document.mozFullScreen || document.webkitIsFullScreen);
  if (!isInFullScreenN && isInFullScreenNOS < 2) {
  fullscreen();
  }

this.addEventListener('click', fullscreen);
// when you are in fullscreen, ESC and F11 may not be trigger by keydown listener. 
// so don't use it to detect exit fullscreen
document.addEventListener('keydown', function (e) {
  //console.log('key press' + e.keyCode);
});
// detect enter or exit fullscreen mode
document.addEventListener('webkitfullscreenchange', fullscreenChange);
document.addEventListener('mozfullscreenchange', fullscreenChange);
document.addEventListener('fullscreenchange', fullscreenChange);
document.addEventListener('MSFullscreenChange', fullscreenChange);
 }); 

 function fullscreen() {
  // check if fullscreen mode is available
  if (document.fullscreenEnabled || 
    document.webkitFullscreenEnabled || 
    document.mozFullScreenEnabled ||
    document.msFullscreenEnabled) {
    
    var isInFullScreen = (document.fullScreenElement && document.fullScreenElement !== null) ||    // alternative standard method  
            (document.mozFullScreen || document.webkitIsFullScreen);

    // which element will be fullscreen
    var iframe = document.querySelector('iframe.modal-iframe');
    if (!isInFullScreen) {
    // Do fullscreen
    if (iframe?.requestFullscreen) {
      iframe?.requestFullscreen();
    } else if (iframe?.webkitRequestFullscreen) {
      iframe?.webkitRequestFullscreen();
    } else if (iframe?.mozRequestFullScreen) {
      iframe?.mozRequestFullScreen();
    } else if (iframe?.msRequestFullscreen) {
      iframe?.msRequestFullscreen();
    }
    }
    else{
      if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if (document.mozCancelFullScreen) {
      document.mozCancelFullScreen();
    } else if (document.webkitExitFullscreen) {
      document.webkitExitFullscreen();
    } else if (document.msExitFullscreen) {
      document.msExitFullscreen();
    }
    }
  }
  else {
    //document.querySelector('.error').innerHTML = 'Your browser is not supported';
    alert('Your browser is not supported');
  }
}

function fullscreenChange() {
  if (document.fullscreenEnabled ||
       document.webkitIsFullScreen || 
       document.mozFullScreen ||
       document.msFullscreenElement) {
    //console.log('enter fullscreen');
  }
  else {
    //console.log('exit fullscreen');
  }
  // force to reload iframe once to prevent the iframe source didn't care about trying to resize the window
  // comment this line and you will see
  var iframe = document.querySelector('iframe.modal-iframe');
  if(iframe?.src != "" && iframe?.src != null && iframe?.src != undefined){
  iframe.src = iframe?.src;
  }
 }

 var go_full_screen_feedback = document.querySelector('.go-full-screen-feedback');
go_full_screen_feedback?.addEventListener('click', fullscreenFeedback);
var isInFullScreenNOSX = 0;

$(document).on('click', '.pop-feedback-modal', function(e){
isInFullScreenNOSX = 0;
});

$(document).on('click', '.go-full-screen-feedback', function(e){
  
  isInFullScreenNOSX++;
  var isInFullScreenNX = (document.fullScreenElement && document.fullScreenElement !== null) ||    // alternative standard method  
            (document.mozFullScreen || document.webkitIsFullScreen);
  if (!isInFullScreenNX && isInFullScreenNOSX < 2) {
  fullscreenFeedback();
  }
  else if(!isInFullScreenNX){
  fullscreenFeedback();
  }
  //alert(isInFullScreenNOSX);

this.addEventListener('click', fullscreenFeedback);
// when you are in fullscreen, ESC and F11 may not be trigger by keydown listener. 
// so don't use it to detect exit fullscreen
document.addEventListener('keydown', function (e) {
  //console.log('key press' + e.keyCode);
});
// detect enter or exit fullscreen mode
document.addEventListener('webkitfullscreenchange', fullscreenChangeFeedback);
document.addEventListener('mozfullscreenchange', fullscreenChangeFeedback);
document.addEventListener('fullscreenchange', fullscreenChangeFeedback);
document.addEventListener('MSFullscreenChange', fullscreenChangeFeedback);
 }); 

 function fullscreenFeedback() {
  // check if fullscreen mode is available
  if (document.fullscreenEnabled || 
    document.webkitFullscreenEnabled || 
    document.mozFullScreenEnabled ||
    document.msFullscreenEnabled) {
    
    var isInFullScreenX = (document.fullScreenElement && document.fullScreenElement !== null) ||    // alternative standard method  
            (document.mozFullScreen || document.webkitIsFullScreen);

    // which element will be fullscreen
    var feedbackframe = document.querySelector('div.feedback-pane');
    if (!isInFullScreenX) {
    // Do fullscreen
    if (feedbackframe?.requestFullscreen) {
      feedbackframe?.requestFullscreen();
    } else if (feedbackframe?.webkitRequestFullscreen) {
      feedbackframe?.webkitRequestFullscreen();
    } else if (feedbackframe?.mozRequestFullScreen) {
      feedbackframe?.mozRequestFullScreen();
    } else if (feedbackframe?.msRequestFullscreen) {
      feedbackframe?.msRequestFullscreen();
    }
    }
    else{
      if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if (document.mozCancelFullScreen) {
      document.mozCancelFullScreen();
    } else if (document.webkitExitFullscreen) {
      document.webkitExitFullscreen();
    } else if (document.msExitFullscreen) {
      document.msExitFullscreen();
    }
    }
  }
  else {
    //document.querySelector('.error').innerHTML = 'Your browser is not supported';
    alert('Your browser is not supported');
  }
}

function fullscreenChangeFeedback() {
  if (document.fullscreenEnabled ||
       document.webkitIsFullScreen || 
       document.mozFullScreen ||
       document.msFullscreenElement) {
    //console.log('enter fullscreen');
  }
  else {
    //console.log('exit fullscreen');
  }
  // force to reload iframe once to prevent the iframe source didn't care about trying to resize the window
  // comment this line and you will see
  var feedbackframe = document.querySelector('div.feedback-pane');
  if(feedbackframe?.innerHTML != "" && feedbackframe?.innerHTML != null && feedbackframe?.innerHTML != undefined){
  feedbackframe.innerHTML = feedbackframe?.innerHTML;
  }
 }



}); 

$(function(){
$(document, window).on('click', '.pp-open-btn', function(e){
    e.preventDefault();
   $('.pp-overlay').removeClass('hidden');
 });
 
 $(document, window).on('click', '.pp-close-btn', function(e){
   e.preventDefault();
   $('.pp-overlay').addClass('hidden');
 });

$(document, window).on('click', '.open-payment-modal', function(e){
let pp_pay_url = $(this).data('paymentUri');
//let pp_that = $(this).data('paymentPlace');

$('.paypal-frame').attr('src', pp_pay_url);
$('.pp-website-link').attr('href', pp_pay_url);
      
setTimeout(function(){
if(pp_pay_url != "" && pp_pay_url != false && pp_pay_url != null && pp_pay_url != 'undefined' && pp_pay_url != undefined){
$('.pp-overlay').removeClass('hidden');
}
else{
//DO Nothing
}
}, 2000);
});
});


$(function(){
  $(document, window).on('keypress keyup keydown', 'input', function(e){
  // look for window.event in case event isn't passed in
   
  e = e || window.event;
 
  if (e.keyCode == 13)
   {
    
    $(document, window).find('.breed-form-x button:not(.no-enter-submit)').click();
    return false;
   //alert("Enter pressed");
   }
   return true;
     });
  });

  $(function(){

    $("#scrollUpdateDash").on({
      mouseenter: function () {
          //stuff to do on mouse enter
         this.stop();
      },
      mouseleave: function () {
          //stuff to do on mouse leave
         this.start();
      }
  });
  });

  }

    componentDidUpdate(prevProps) { 
      
    }

    componentWillUnmount(){

    }

// Calculates the best possible position of an image on the A4 paper format,
// so that the maximal area of A4 is used and the image ratio is preserved.
imageDimensionsOnA4 = (dimensions) => {

  const isLandscapeImage = dimensions.width >= dimensions.height;

  // If the image is in landscape, the full width of A4 is used.
  if (isLandscapeImage) {
    return {
      width: A4_PAPER_DIMENSIONS.width,
      height:
        A4_PAPER_DIMENSIONS.width / (dimensions.width / dimensions.height),
    };
  }

  // If the image is in portrait and the full height of A4 would skew
  // the image ratio, we scale the image dimensions.
  const imageRatio = dimensions.width / dimensions.height;
  if (imageRatio > A4_PAPER_RATIO) {
    const imageScaleFactor =
      (A4_PAPER_RATIO * dimensions.height) / dimensions.width;

    const scaledImageHeight = A4_PAPER_DIMENSIONS.height * imageScaleFactor;

    return {
      height: scaledImageHeight,
      width: scaledImageHeight * imageRatio,
    };
  }

  // The full height of A4 can be used without skewing the image ratio.
  return {
    width: A4_PAPER_DIMENSIONS.height / (dimensions.height / dimensions.width),
    height: A4_PAPER_DIMENSIONS.height,
  };
};

 getMimeTypeFromBase64Url(url) {
  if(url != undefined && url?.length > 8){
  const base64Marker = ';base64,';
  const mimeTypeMarker = 'data:';
  const pos = url?.indexOf(base64Marker) + base64Marker?.length;
  const mimeType = url?.substring(mimeTypeMarker?.length, pos - base64Marker?.length);
  return mimeType;
  }
  return false;
}

async getImageDimension(image){
  var dimensions = await this.getImageDimensions(image);
    //alert(JSON.stringify(dimensions));
   // return dimensions;
}

getImageDimensions(file) {
  return new Promise (function (resolved, rejected) {
    var i = new Image()
    i.onload = function(){
      resolved({width: i.width, height: i.height})
    };
    i.src = file;
  })
}

getImageRawData(file){
  let that = this;

  return new Promise (function (resolved, rejected) {
    var i = new Image()
    i.onload = function(){
      resolved({width: i.width, height: i.height, imageType: that.getMimeTypeFromBase64Url(file), src: file})
    };
    i.src = file;
  })
}

// Creates a PDF document containing all the uploaded images.
async generatePdfFromImages(images, name = ""){
  // Default export is A4 paper, portrait, using millimeters for units.
  const doc = new jsPDF();

  // We let the images add all pages,
  // therefore the first default page can be removed.
  doc.deletePage(1);

  var img = await this.getImageRawData(images[0]);
     //alert(JSON.stringify(dimensions));

  images.forEach((image) => {
    const imageDimensions = this.imageDimensionsOnA4({
      width: img.width,
      height: img.height,
    });

    doc.addPage();
    doc.addImage(
      img.src,
      img.imageType,
      // Images are vertically and horizontally centered on the page.
      (A4_PAPER_DIMENSIONS.width - imageDimensions.width) / 2,
      (A4_PAPER_DIMENSIONS.height - imageDimensions.height) / 2,
      imageDimensions.width,
      imageDimensions.height,
    );
  });

  let fileName = name?.length ? name+'.pdf' : 'file-summary.pdf';

  doc.save(fileName);   //Download the rendered PDF.
};

DownloadBlobPDFFile(dataUri, name = 'file.pdf'){
  fetch(dataUri)
  .then(response => response.blob())
  .then(blob => {
    // create a blobURI pointing to our Blob
    const url = URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.setAttribute('title', name);
      link.setAttribute('href', url);
      link.setAttribute('download', name);
      document.body.appendChild(link);
      link.click();

      // cleanup: remove element and revoke object URL
     document.body.removeChild(link);
     // in case the Blob uses a lot of memory
     setTimeout(() => URL.revokeObjectURL(url), 5000);
  });
}

  render(){
  return (
    <div className="App">
      
     <BrowserRouter>
   <Switch>
   <Route exact path="/" component={Index}></Route>
   <Route exact path="/home" component={Index}></Route>
   <Route exact path="/index" component={Index}></Route>
   <Route exact path="/login" component={Login}></Route>
   <Route exact path="/register" component={Register}></Route>
   <Route exact path="/register/:a" component={Register}></Route>
   <Route exact path="/recover" component={Recover}></Route>
   <Route exact path="/reset/:id/:token" component={Reset}></Route>
   <Route exact path="/dashboard" component={Dashboard}></Route>
   <Route exact path="/change/password" component={ChangePassword}></Route>
   <Route exact path="/change/contact" component={ChangeAccount}></Route>
   <Route exact path="/change/account" component={ChangeAccount}></Route>
   <Route exact path="/change/field" component={ChangeField}></Route>
   <Route exact path="/change/role" component={ChangeRole}></Route>
   <Route exact path="/submit" component={Submit}></Route>
   <Route exact path="/resubmit" component={Resubmit}></Route>
   <Route exact path="/my-submission" component={MySubmission}></Route>
   <Route exact path="/my-review" component={MyReview}></Route>
   <Route exact path="/my-commit" component={MyCommit}></Route>
   <Route exact path="/feedback" component={Feedback}></Route>
   <Route exact path="/review" component={Review}></Route>
   <Route exact path="/publisher" component={Publisher}></Route>
   <Route exact path="/publisher/:id" component={Publisher}></Route>
   <Route exact path="/editors" component={Editors}></Route>
   <Route exact path="/summary" component={Summary}></Route>
   <Route exact path="/downloads" component={Downloads}></Route>
   <Route exact path="/details" component={Details}></Route>
   <Route exact path="/editdetails/:id" component={Editdetails}></Route>
   <Route exact path="/wallet" component={Wallet}></Route>
   <Route exact path="/repository" component={Repository}></Route>
   <Route exact path="/contact" component={Contact}></Route>
   <Route exact path="/paypal-cancel" component={PayPalCancel}></Route>
   <Route exact path="/paypal-success" component={PayPalSuccess}></Route>
   <Route path="*">
            <NotFound />
          </Route>
   </Switch>
    </BrowserRouter>

    <div className="pp-overlay hidden" id="pp-overlay">
 <div className="pp-overlay-modal">
<div className="pp-modal">
  <div className="pp-content">
    <a className="pp-close-btn" href="#0">X</a>
    <a className="pp-blank-link" href="#"></a>
    <a className="pp-website-link" target="_blank" doskip="1" href="https://www.paypal.com">Open PayPal &raquo;</a>
    <span className="pp-skip-ad hidden">Skip ad: 5</span>
    <div className="pp-iframe-container">
      <iframe src="https://www.paypal.com/checkoutnow?token=5O190127TN364715T" allowfullscreen="" frameborder="0" doskip="1" className="paypal-frame"></iframe>
    </div>
  </div>
</div>
</div>
</div>

    <div className="modal-content-overlay">

    <div className="modal-wrap-large">
        <div className="modal-large">
    <div className="modal-head"><span className="large-modal-data-title">Head</span> 
    <span className="close close-modal"><i className="fa fa-times"></i></span></div>
    <div className="modal-body">

    <div className="large-modal-data-body">My Body 
    </div>
    </div>
     <div className="modal-foot"><span className="close close-modal">
        <i className="fa fa-times"></i> Close</span></div>
        </div>
        </div>
     
     <div className="modal-wrap-small">
        <div className="modal-small">
    <div className="modal-head"><span className="small-modal-data-title">Head</span> 
    <span className="close close-modal"><i className="fa fa-times"></i></span></div>
    <div className="modal-body">
    <div className="small-modal-data-body">My Body 
    </div>
    </div>

    <div className="modal-foot"><span className="close close-modal">
        <i className="fa fa-times"></i> Close</span></div>
    </div>
    </div>

    </div>

    </div>
  );
  }
}

export default App;
